/**
 * Modals Module
 * Handles modal interactions and triggers
 */

import { createSwiperWithPreset } from '../utils/swiperConfig.js';
import { $, $$, on, exists, addClass, removeClass, attr } from '../utils/dom.js';

export const initSideContentBrand = () => {
  if (exists(".side-content-brand")) {
    on($$(".button--modal"), "click", function (e) {
      e.preventDefault();
      const modal = attr(this, "data-brand-modal");
      addClass($(`.side-content-brand__modal[data-brand-modal="${modal}"]`), "active");
      addClass($(`.side-content-brand__modal-overlay[data-brand-modal="${modal}"]`), "active");
      addClass(document.body, "modal-open");
    });

    on($$(".side-content-brand__modal__close, .side-content-brand__modal-overlay"), "click", function (e) {
      e.preventDefault();
      removeClass(".side-content-brand__modal", "active");
      removeClass(".side-content-brand__modal-overlay", "active");
      removeClass(document.body, "modal-open");
    });
  }
};

export const initCardSDGModule = () => {
  if (exists(".card-sdg-module__swiper")) {
    const swiperElement = $(".card-sdg-module__swiper");
    const slides = swiperElement ? swiperElement.querySelectorAll('.swiper-slide') : [];

    if (slides.length >= 3) {
      const cardSDGModule = createSwiperWithPreset(
        ".card-sdg-module__swiper",
        "cardSDGCarousel",
        {
          navigation: {
            nextEl: ".card-sdg-module__next",
            prevEl: ".card-sdg-module__prev",
          },
        }
      );
    } else {
      addClass(".card-sdg-module", "centered");
    }
  }

  on($$(".card-sdg-module .modal-trigger"), "click", function (e) {
    e.preventDefault();
    const modal = attr(this, "data-modal");
    addClass($(`.modal[data-modal="${modal}"]`), "active");
    addClass(document.body, "modal-open");
  });

  on($$(".modal__close, .modal__overlay"), "click", function (e) {
    e.preventDefault();
    removeClass(".modal", "active");
    removeClass(document.body, "modal-open");
  });
};

export const initLaunchTextWithModal = () => {
  if (exists(".launch-text-with-modal")) {
    on($$(".launch-text-with-modal__cta a"), "click", function (e) {
      e.preventDefault();
      const modal = $(".launch-text-with-modal__modal");
      addClass(modal, "active");
      addClass(".launch-text-with-modal__modal-overlay", "active");
      addClass(document.body, "modal-open");
    });

    on($$(".launch-text-with-modal__modal__close, .launch-text-with-modal__modal-overlay"), "click", function (e) {
      e.preventDefault();
      removeClass(".launch-text-with-modal__modal", "active");
      removeClass(".launch-text-with-modal__modal-overlay", "active");
      removeClass(document.body, "modal-open");
    });
  }
};

export const initLeadershipTeam = () => {
  if (exists(".leadership-team")) {
    on($$(".leadership-team__member"), "click", function () {
      const modalId = attr(this, "data-modal");
      addClass($(`[data-modal="${modalId}"].modal`), "active");
      addClass(document.body, "modal-open");
    });

    // Close buttons for leadership modals
    const leadershipModals = $$('[data-modal^="leadership-modal-"].modal');
    leadershipModals.forEach((modal) => {
      const closeBtn = modal.querySelector(".modal__close");
      const overlay = modal.querySelector(".modal__overlay");

      if (closeBtn) {
        on(closeBtn, "click", function () {
          removeClass(modal, "active");
          removeClass(document.body, "modal-open");
        });
      }

      if (overlay) {
        on(overlay, "click", function () {
          removeClass(modal, "active");
          removeClass(document.body, "modal-open");
        });
      }
    });
  }
};

export const initLaunchTextModal = () => {
  if (exists(".launch-text .modal-trigger")) {
    on($$(".launch-text .modal-trigger"), "click", function (e) {
      e.preventDefault();
      const modal = attr(this, "data-modal");
      addClass($(`.modal[data-modal="${modal}"]`), "active");
      addClass(document.body, "modal-open");
    });

    const launchTextModal = $(`.modal[data-modal="launch-text-cta-modal"]`);
    if (launchTextModal) {
      const closeBtn = launchTextModal.querySelector(".modal__close");
      const overlay = launchTextModal.querySelector(".modal__overlay");

      if (closeBtn) {
        on(closeBtn, "click", function () {
          removeClass(launchTextModal, "active");
          removeClass(document.body, "modal-open");
        });
      }

      if (overlay) {
        on(overlay, "click", function () {
          removeClass(launchTextModal, "active");
          removeClass(document.body, "modal-open");
        });
      }
    }
  }
};

export const initContentModuleTopModals = () => {
  if (exists(".content-module-composition__top")) {
    // Trigger modals from CTA buttons
    on($$(".content-module-composition__top .modal-trigger"), "click", function (e) {
      e.preventDefault();
      const modal = attr(this, "data-modal");
      addClass($(`.modal[data-modal="${modal}"]`), "active");
      addClass(document.body, "modal-open");
    });

    // Close buttons for content module top modals
    const contentModuleModals = $$('.content-module-composition__top .modal');
    contentModuleModals.forEach((modal) => {
      const closeBtn = modal.querySelector(".modal__close");
      const overlay = modal.querySelector(".modal__overlay");

      if (closeBtn) {
        on(closeBtn, "click", function () {
          removeClass(modal, "active");
          removeClass(document.body, "modal-open");
        });
      }

      if (overlay) {
        on(overlay, "click", function () {
          removeClass(modal, "active");
          removeClass(document.body, "modal-open");
        });
      }
    });
  }
};
